import React from 'react';
import { StoreGrid } from './index';
import { jsx as _jsx } from "react/jsx-runtime";

function SimpleStoreGrid(_ref) {
  let {
    title,
    shortDescription,
    entries,
    callToAction,
    as,
    clickEvent
  } = _ref;
  const retailers = entries.map((entry, index) => ({
    title: entry.title,
    shortDescription: entry.shortDescription || undefined,
    logoUrl: entry.image.url,
    url: entry.callToAction.url,
    as: entry.as,
    index,
    viewItem: entry.viewItem
  }));
  return /*#__PURE__*/_jsx(StoreGrid, {
    retailers: retailers,
    title: title,
    subtitle: shortDescription,
    callToAction: callToAction,
    as: as,
    clickEvent: clickEvent,
    "data-id": "store-grid_simple-store-grid_SimpleStoreGrid_StoreGrid"
  });
}

export default SimpleStoreGrid;